module.exports = __webpack_public_path__ + "static/media/graphic.11e98f9e.png";